import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import AppIndex from "./pages/Home";
// import "../App.css";

const AppLayout = () => {
  return (
    <div>
      {/* <header>
        <nav className="nav-header">
          <NavLink to="#">Login</NavLink>
          <NavLink to="#">Register</NavLink>
        </nav>
      </header> */}

      <main>
        <Outlet />
        <AppIndex />
      </main>
    </div>
  );
};

export default AppLayout;
